/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  index.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:27
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import Vue from "vue";
import VueRouter from "vue-router";
import { constantRouterMap } from "@/config/router.config";
import store from '@/store/index'

// hack router push callback
const originalPush = VueRouter.prototype.push;
const originalBack = VueRouter.prototype.back;
// @ts-ignore
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  // store.commit("SET_TRANSITION", "turn-on");
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  // @ts-ignore
  return originalPush.call(this, location).catch((err) => err);
};

// @ts-ignore
VueRouter.prototype.back = function back(location) {
  // store.commit("SET_TRANSITION", "turn-off");
  // @ts-ignore
  return originalBack.call(this, location);
};

Vue.use(VueRouter);

export default new VueRouter({
  mode: "history",
  // base: process.env.BASE_URL,
  routes: constantRouterMap,
});
